export enum UserRoles {
    Administrator = 1,
    TeilAdministrator,
    Veranstalter,
    Benutzer
}

export default class UserRolesModel {
    id: number
    description: string
}